import {Trans, useTranslation} from "ni18n";
import React from "react";
import {ImageItemList} from "src/components/_common/ImageItemList";
import {useTypedSelector} from "src/store";

import {IllustratedTextDecoration} from "../IllustratedTextDecoration";
import {Btn} from "../V5Comp";

type Props = {
  nextApptSlot: string;
  bookingUrl: string;
  bookingBtnHandler: () => void;
};

const About: React.FC<Props> = ({nextApptSlot, bookingUrl, bookingBtnHandler}) => {
  const i18n = useTranslation();
  const {isMobile} = useTypedSelector(state => state.config);

  const imageHeight = isMobile ? 100 : 170;
  const itemList = [
    {
      header: i18n.t("You've tested positive.\nNow what?"),
      content: i18n.t(
        "You might have to isolate, but you’re never alone. Carbon Health is here to provide targeted care and answer all of your COVID related questions.",
      ),
      image: {
        src: "illustrations/virus",
        height: imageHeight,
      },
    },
    {
      header: i18n.t("Chat with our\nfriendly providers"),
      content: i18n.t(
        "There is no cost or insurance co-pay needed to enroll and unlimited virtual visits are available until you are fully recovered.",
      ),
      image: {
        src: "home/illustrated-list/02",
        height: imageHeight,
      },
    },
    {
      header: i18n.t("Continuous care\nafter your call"),
      content: i18n.t(
        "With symptom management, continuous monitoring, and mental health screenings we’ll help you manage your health and ensure your life gets back on track.",
      ),
      image: {
        src: "reason/virtualCare/continuous",
        height: imageHeight,
      },
    },
  ];
  return (
    <div className="">
      <div className="ma w100p maxw80 ph10 ph4-sm pt20 pb30 pv14-md">
        <h2 className="tal mb10">
          <Trans>
            <span className="zIndex2 pos-r">
              Personalized virtual
              <br />
              care{" "}
            </span>
            <span className="darkerGreen pos-r zIndex1">
              on demand
              <IllustratedTextDecoration type="circle" width="130%" style={{top: 3}} />
            </span>
          </Trans>
        </h2>
        <ImageItemList rows={1} items={itemList} />
        <div className="df aic fdc-sm aifs-sm">
          <Btn href={bookingUrl} onClick={bookingBtnHandler} className="mr5">
            {i18n.t("Talk to a Virtual Provider")}
          </Btn>
          <div className="df fdc ml6-sm mt3-sm">
            <div className="green font-csb mb1 fs18 fs14-sm font-ib-sm">{nextApptSlot}</div>
            <div className="font-im gray400 fs14">{i18n.t("$0 to enroll")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
